export const PROCESSES_MODALS = {
  create: 'create',
  delete: 'delete',
};

export const DEFAULT_PROCESS = {
  _id: '',
  title: '',
  createdBy: '',
};
